import { Box, Stack } from '@mui/material';
import { useState } from 'react';
import DecoratedChip from './DecoratedChip';
import FileModal from './file-modal';

interface FilesSectionProps {
  urls: string[];
  filesToShow: number;
  onChipClick: (url: string) => void;
}

function FilesSection({
  urls,
  filesToShow = 3,
  onChipClick,
}: FilesSectionProps): React.ReactNode {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = (): void => {
    setModalOpen(true);
  };

  const handleCloseModal = (): void => {
    setModalOpen(false);
  };

  return (
    <Box>
      <Stack spacing={1}>
        <Box display="grid" gridTemplateColumns={`repeat(4, 1fr)`} gap={1}>
          {urls.slice(0, filesToShow).map((url) => (
            <DecoratedChip
              key={url}
              onClick={() => {
                onChipClick(url);
              }}
              size="medium"
              sx={{
                height: '5vh',
                width: '10vw',
                fontSize: '1rem',
                borderRadius: '10px',
              }}
              url={url}
            />
          ))}
          {urls.length > filesToShow && (
            <DecoratedChip
              // color="success"
              label={`See All Files (${urls.length})`}
              onClick={handleOpenModal}
              size="medium"
              sx={{
                height: '5vh',
                width: '10vw',
                fontSize: '1rem',
                borderRadius: '10px',
              }}
              title={`See All Files (${urls.length})`}
              url=""
              variant="outlined"
            />
          )}
        </Box>
      </Stack>
      <FileModal
        modalOpen={modalOpen}
        onClose={handleCloseModal}
        urls={urls}
        onChipClick={onChipClick}
      />
    </Box>
  );
}

export default FilesSection;
